import React from "react";

const TransportServiceArea = () => {
  return (
    <>
      {/* Transport service area start */}

      <div>
        <div
          className=""
          style={{
            backgroundColor: "rgba(8, 12, 36, 0.9)",
            padding: 20,
            color: "white",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title  text-center">
                  <span className="subtitle">Our Services</span>
                  <h2 className="title" style={{ color: "white" }}>
                    What We Can Do For You
                  </h2>
                </div>
              </div>
            </div>
            <div className="row transport-service-single">
              <div className="col-lg-6">
                <div className="transport-service-image wow fadeInLeft">
                  <img
                    src="/2151541908.jpg"
                    className="img-fluid"
                    alt="transport-service images"
                  />
                  <div className="transport-service-item-hover">
                    <a href="/">
                      <div className="transport-service-link">
                        <span className="fa fa-eye" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 offset-lg-1 d-flex">
                <div className="transport-service-content wow fadeInRight">
                  <h3 className="title" style={{ color: "white" }}>
                    Truck Transport Services
                  </h3>
                  <p>
                    Reliable truck transport services to ensure safe and timely
                    delivery of goods across regions with flexible scheduling
                    options.
                  </p>
                  <div className="btn-wrapper animated fadeInUpBig text-left">
                    <a href="/" className="boxed-btn blank">
                      Contact for transport
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row transport-service-single">
              <div className="col-lg-6 offset-lg-1 order-lg-2">
                <div className="transport-service-image wow fadeInRight">
                  <img
                    src="/2151468807.jpg"
                    className="img-fluid"
                    width={600}
                    alt="transport-service images"
                  />
                  <div className="transport-service-item-hover">
                    <a href="/">
                      <div className="transport-service-link">
                        <span className="fa fa-eye" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 offset-lg-1 d-flex ">
                <div className="transport-service-content wow fadeInLeft">
                  <h3 className="title" style={{ color: "white" }}>
                    Warehouse Storage
                  </h3>
                  <p>
                    Efficient and secure storage solutions for all your
                    warehousing needs, ensuring optimal space utilization and
                    quick access.
                  </p>
                  <div className="btn-wrapper animated fadeInUpBig text-left">
                    <a href="/" className="boxed-btn blank">
                      Contact for transport
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row transport-service-single">
              <div className="col-lg-6">
                <div className="transport-service-image wow fadeInLeft">
                  <img
                    src="/flatbed1.jpeg"
                    className="img-fluid"
                    alt="transport-service images"
                  />
                  <div className="transport-service-item-hover">
                    <a href="/">
                      <div className="transport-service-link">
                        <span className="fa fa-eye" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 offset-lg-1 d-flex">
                <div className="transport-service-content wow fadeInRight">
                  <h3 className="title" style={{ color: "white" }}>
                    Flatbed and Oversize
                  </h3>
                  <p>
                    At Prime Logistics, we specialize in flatbed and oversize
                    truck transport services to handle even the most challenging
                    shipments.
                  </p>
                  <div className="btn-wrapper animated fadeInUpBig text-left">
                    <a href="/" className="boxed-btn blank">
                      Contact for transport
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-2">
                <div className="btn-wrapper animated fadeInUpBig text-center">
                  <a href="/service" className="boxed-btn btn-bounce">
                    View All Services
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Transport service area end */}
    </>
  );
};

export default TransportServiceArea;
